import React from 'react';
import Lottie from 'react-lottie';
import animationData from '../../lotties/training-completed.json';
import { replaceColor } from 'lottie-colorify';

export function TrainingCompletedAnimation ({ primaryColor }){
    const defaultOptions = {
        loop: false,
        autoplay: true,
        animationData: replaceColor('#20A26B', primaryColor, animationData),
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
        },
    };

    return <Lottie options={defaultOptions} />;
};
